import React, { useEffect } from "react";
import { TextField } from "@mui/material";

const ProductLabelQuantityField = ({ product, updateQuantity }) => {
	const [quantityInput, setQuantityInput] = React.useState(product.quantity ?? 1);
	useEffect(() => {
		if (product.quantity !== "" && product.quantity !== 0) {
			setQuantityInput(product.quantity ?? 1);
		}
	}, [product.quantity]);

	return (
		<TextField
			type="number"
			variant="outlined"
			value={quantityInput}
			onChange={(e) => {
				const value = e.target.value;
				setQuantityInput(value);
				updateQuantity(value);
			}}
			slotProps={{ htmlInput: { min: 0 } }}
			style={{ width: "60px", textAlign: "center" }}
			onBlur={(e) => {
				if (quantityInput === "") {
					setQuantityInput(1);
					updateQuantity(1);
				}
			}}
		/>
	);
};

export default ProductLabelQuantityField;
